/**
 * DraftsList Component
 * Shows available drafts in the SELECT tab when no draft is active.
 * Each card displays draft metadata with Resume / Abandon actions.
 */

import {
  DocumentDuplicateIcon,
  ArrowPathIcon,
  TrashIcon,
} from '@heroicons/react/24/outline';
import { OathButton } from '../../../shared/OathUI';
import { formatCurrencyWithSymbol, formatDate } from '../utils/formatters';

const DraftsList = ({ drafts, onResume, onAbandon }) => {
  if (!drafts || drafts.length === 0) return null;

  return (
    <div className="mb-6 space-y-3">
      <h3 className="text-sm qhd:text-base font-semibold text-gray-700 dark:text-gray-300 flex items-center gap-2">
        <DocumentDuplicateIcon className="h-4 w-4 qhd:h-5 qhd:w-5" />
        Saved Drafts
      </h3>
      {drafts.map((draft) => (
        <div
          key={draft.reportId}
          className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden shadow-sm"
        >
          <div className="h-0.5 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-400" />
          <div className="p-3 sm:p-4 qhd:p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4">
            <div className="min-w-0 flex-1">
              <p className="text-sm qhd:text-base font-bold text-gray-900 dark:text-white truncate">
                {draft.reportNumber || `Draft ${draft.reportId}`}
              </p>
              <p className="text-xs qhd:text-sm text-gray-500 dark:text-gray-400 mt-0.5">
                {draft.powerCount} power{draft.powerCount !== 1 ? 's' : ''}
                {draft.totalLiability > 0 && (
                  <> &mdash; {formatCurrencyWithSymbol(draft.totalLiability)}</>
                )}
                {draft.dateCreated && (
                  <> &mdash; Created {formatDate(draft.dateCreated)}</>
                )}
              </p>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <OathButton
                variant="outline"
                size="sm"
                icon={TrashIcon}
                onClick={() => onAbandon(draft.reportId)}
                className="flex-1 sm:flex-initial"
              >
                Abandon
              </OathButton>
              <OathButton
                size="sm"
                icon={ArrowPathIcon}
                onClick={() => onResume(draft.reportId)}
                className="flex-1 sm:flex-initial"
              >
                Resume
              </OathButton>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DraftsList;
